var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"video",staticClass:"sideblock-select-lens-cover-video",attrs:{"poster":_vm.poster,"playsinline":"","autoplay":"","loop":"","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.src,"type":"video/mp4"}})])}
var staticRenderFns = []

export { render, staticRenderFns }